export default __webpack_public_path__ + "static/media/background-sign-mobile.ba7d7e4f.jpg";